import AccessoryCommon from "./accessoryCommon";

export default class LargeShelf extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'large_shelf';
    this.partName = 'Large Shelf';
    this.translateId = "visualizer.bathroom.accessories.large_shelf";
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new LargeShelf());
  }

  handleClick() { // "this" is feature!! not the feature group
    const parent = this.getParent();
    const accessoriesParent = parent.getParent();
    if (accessoriesParent && accessoriesParent.showerPod && !accessoriesParent.showerPod.disabled) {
      accessoriesParent.showerPod.disabled = true;
    }
    super.handleClick();
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Accessories.LargeShelf;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

}
